import Button from 'tio-reimagined/components/button';
import { htmlSafe } from '@ember/template';
import { on } from '@ember/modifier';
import { PhTrash } from 'ember-phosphor-icons';
import { t } from 'ember-intl';
import { tracked } from '@glimmer/tracking';
import { VStack } from 'tio-reimagined/components/layout';
import Component from '@glimmer/component';
import signaturePad from '../modifiers/signature-pad';
import type { PointGroup } from 'signature_pad';

interface SignaturePadArgs {
  Args: {
    onSignatureUpdate: (points: PointGroup[], signatureUrl: string) => void;
    errors?: string[];
  };
  Element: HTMLDivElement;
}

export default class SignaturePadComponent extends Component<SignaturePadArgs> {
  @tracked signaturePoints: PointGroup[] = [];
  @tracked signatureImage: string = '';
  @tracked hadExistingSignatureOnInit = false;

  onSignatureUpdate = (points: PointGroup[], signatureUrl: string) => {
    this.signaturePoints = points;
    this.signatureImage = signatureUrl;
    this.args.onSignatureUpdate(points, signatureUrl);
  };

  onClearSignature = () => {
    this.signaturePoints = [];
    this.signatureImage = '';
    this.args.onSignatureUpdate([], '');
  };

  <template>
    <VStack class="w-full flex flex-col items-center" ...attributes>
      <Button
        @appearance="minimal"
        @size="sm"
        class="flex items-center ml-auto"
        {{on "click" this.onClearSignature}}
        data-test="btn-clear-signature"
      >
        <PhTrash @size="16" class="mr-2 my-auto" />
        {{t "common.pslf.clear_signature"}}
      </Button>
      <div
        class="w-full min-h-[120px] sm:min-h-[150px] max-w-[800px] border-2 border-gray-400 bg-white rounded-md flex items-center justify-center"
        style={{htmlSafe "aspect-ratio: 2 / 1;"}}
      >
        <canvas
          class="w-full h-full"
          {{signaturePad onEnd=this.onSignatureUpdate signaturePoints=this.signaturePoints}}
          data-test="signature-pad-canvas"
        />
      </div>
      {{#if @errors}}
        <div class="w-full">
          {{#each @errors as |error|}}
            <span class="text-red-500 text-sm block">{{error}}</span>
          {{/each}}
        </div>
      {{/if}}
    </VStack>
  </template>
}
